import React from 'react'
import { Box, Typography } from '@mui/material'
import errorImage from "../../assets/images/illustration-404.svg"

const NotFound = () => {
  return (
    <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}>
        <Typography sx={{
            fontSize: "32px",
            fontWeight: 600,
            textAlign: "center",
            mb: 3,
        }}>
        Sorry, Page Not Found!
        </Typography>
        <Typography sx={{
            fontSize: "18px",
            fontWeight: 400,
            textAlign: "center",
            color: "#667085",
            mb: 5,
        }}>
        Sorry, we couldn’t find the page you’re looking for.
        </Typography>
        <img 
        src={errorImage} 
        alt="not found" 
        style={{ maxWidth: "100%", height: "auto" }}
        />
    </Box>
  )
}

export default NotFound